import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';
import { DashboardAccess } from '../utils/dashboard.models';

@Injectable()
export class DashboardAccessService {
  constructor(
    private readonly http: HttpClient,
    private readonly currentUserService: CurrentUserService
  ) { }

  readonly rights$ = this.http.get<any>('/api/currentUserAccessRights').pipe(shareReplay(1));
  readonly fullDetails$ = this.currentUserService.getFullAccountDetails().pipe(
    map((result) => result?.data ?? null),
    shareReplay(1)
  );

  readonly access$ = combineLatest([this.rights$, this.fullDetails$]).pipe(
    map(([rights, fullDetails]): DashboardAccess => {
      const combined = Array.isArray(rights?.combinedAccess) ? rights.combinedAccess : [];
      const permissions = fullDetails?.effectivePermissions || {};

      const hasOpexFromRights = combined.map((x: string) => String(x).toLowerCase()).includes('eicassetmap/opex');
      const hasOpex = hasOpexFromRights || this.hasPermission(permissions?.OPEX?.accessType);
      const hasCapex = this.hasPermission(permissions?.CAPEX?.accessType);
      const hasCombinedFromRights = hasCapex && hasOpex;

      return { hasCapex, hasOpex, hasCombinedFromRights };
    }),
    shareReplay(1)
  );

  private hasPermission(accessType: unknown): boolean {
    if (typeof accessType !== 'string') {
      return false;
    }

    const normalized = accessType.trim().toLowerCase();
    return normalized !== '' && normalized !== 'none' && normalized !== 'noaccess';
  }
}
